/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdminInviteUserRequest
 */
export interface AdminInviteUserRequest {
    /**
     * 
     */
    email: string;
    /**
     * 
     */
    firstName: string;
    /**
     * 
     */
    lastName: string;
    /**
     * 
     */
    phone?: string | null;
}

/**
 * Check if a given object implements the AdminInviteUserRequest interface.
 */
export function instanceOfAdminInviteUserRequest(value: object): value is AdminInviteUserRequest {
    if (!('email' in value) || value['email'] === undefined) return false;
    if ((!('firstName' in (value as Record<string, any>)) && !('first_name' in (value as Record<string, any>))) || ((value as Record<string, any>)['firstName'] === undefined && (value as Record<string, any>)['first_name'] === undefined)) return false;
    if ((!('lastName' in (value as Record<string, any>)) && !('last_name' in (value as Record<string, any>))) || ((value as Record<string, any>)['lastName'] === undefined && (value as Record<string, any>)['last_name'] === undefined)) return false;
    return true;
}

export function AdminInviteUserRequestFromJSON(json: any): AdminInviteUserRequest {
    return AdminInviteUserRequestFromJSONTyped(json, false);
}

export function AdminInviteUserRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminInviteUserRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'],
        'firstName': json['first_name'],
        'lastName': json['last_name'],
        'phone': json['phone'] === undefined ? undefined : json['phone'] === null ? null : json['phone'],
    };
}

export function AdminInviteUserRequestToJSON(json: any): AdminInviteUserRequest {
    return AdminInviteUserRequestToJSONTyped(json, false);
}

export function AdminInviteUserRequestToJSONTyped(value?: AdminInviteUserRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'email': value['email'],
        'first_name': value['firstName'],
        'last_name': value['lastName'],
        'phone': value['phone'],
    };
}

